import { string } from "prop-types";

/**
 * Checks if the first version is greater than or equal to the second version
 * @param {string} v1 - First version to compare
 * @param {string} v2 - Second version to compare
 * @returns {boolean} true if v1 >= v2, false if v1 < v2
 *
 * @example
 * isVersionGreaterOrEqual("8.1.0", "8.0.3") // true
 * isVersionGreaterOrEqual("8.0.3", "8.1.0") // false
 * isVersionGreaterOrEqual("8.0.3", "8.0.3") // true
 */
export const isVersionGreaterOrEqual = (v1, v2) => {
	const normalize = (v, len) =>
		v
			.split(".")
			.map(Number)
			.concat(Array(len).fill(0))
			.slice(0, len);

	const maxLength = Math.max(v1.split(".").length, v2.split(".").length);
	const [a, b] = [normalize(v1, maxLength), normalize(v2, maxLength)];

	for (let i = 0; i < maxLength; i += 1) {
		if (a[i] < b[i]) return false;
		if (a[i] > b[i]) return true;
	}

	return true;
};

isVersionGreaterOrEqual.propTypes = {
	v1: string,
	v2: string,
};
